import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import PersonIcon from "@mui/icons-material/Person";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { BasicMultiSelect, BasicSelect } from "../../utils/helperdata";
import "./tableStyles.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllConversationSearchAPI,
  fetchFilterUserAPI,
} from "../../redux/action/UserAction";
import { setDateRange, userSelector } from "../../redux/slices/userSlice";
import { FailureToast } from "../../utils/commonunctions";

// Modal styling configuration
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 520,
  height: 300,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "15px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

export default function FormDialog({
  open,
  setOpen,
  selectedDateLabel,
  setSelectedDateLabel,
  setShowFilter,
}) {
  const dispatch = useDispatch();
  const { filterUserData, searchValue, startDate, endDate } = useSelector(userSelector);
  const groupID = sessionStorage.getItem("currentGrp");

  // State to manage user and filter selections
  const [personName, setPersonName] = React.useState([]);
  const [valid, setValid] = React.useState([]);

  // Fetch users when modal opens
  React.useEffect(() => {
    dispatch(fetchFilterUserAPI(groupID));
  }, []);

  // Close modal and clear filters
  const handleClose = () => {
    setOpen(false);
    setDateRange({
      startDate: "",
      endDate: "",
    });
    
  };

  // Handle user multi-select change
  const handleChange2 = (event) => {
    const {
      target: { value },
    } = event;

    setValid(value);
  };

  // Apply filters and close modal
  const handleFilter = () => {
    const hasDateLabel = selectedDateLabel?.trim() !== "";
    const hasValidSelection = Array.isArray(valid) && valid.length > 0;

    if (!hasDateLabel && !hasValidSelection) {
      FailureToast("Please choose at least one filter option");
      return;
    }

    handleClose();

    dispatch(
      fetchAllConversationSearchAPI(
        null,
        searchValue,
        startDate,
        endDate,
        false,
        valid
      )
    );

    setShowFilter(true);
  };

  // Input configurations for date and user filters
  const filterInput = [
    {
      labelText: "Select Date",
      type: "select",
      labelIcon: <CalendarMonthOutlinedIcon sx={{ mr: 1, color: "gray" }} />,
      options: [
        { optionLabel: "Today", optionValue: "Today" },
        { optionLabel: "Yesterday", optionValue: "Yesterday" },
        { optionLabel: "Past Week", optionValue: "Past Week" },
        { optionLabel: "Past Month", optionValue: "Past Month" },
      ],
    },
          

    {
      labelText: "Select User",
      type: "multi",
      labelIcon: <PersonIcon sx={{ mr: 1, color: "gray" }} />,
      value: valid,
      handleChange: handleChange2, 
      options: filterUserData?.map((e) => ({
        optionLabel: e?.username,
        optionValue: e?.id,
      })),
      
    },
  ];

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          backgroundColor: "transparent",
          backdropFilter: "none",
        }}
      >
        <Box sx={style}>
          <div>
            {/* Modal Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <p style={{ fontSize: "18px", fontWeight: "500" }}>Filter</p>
              <CloseIcon sx={{ cursor: "pointer" }} onClick={handleClose} />
            </div>

            <hr />

            {/* Filter Controls */}
            <div className="select-wrapper">
              {filterInput?.map((e) => (
                <div key={e.labelText} style={{ width: "48%" }}>
                  {e?.type === "select" ? (
                    <BasicSelect
                      labelText={e?.labelText}
                      labelIcon={e?.labelIcon}
                      options={e?.options}
                      dispatch={dispatch}
                      setDateRange={setDateRange}
                      selectedDateLabel={selectedDateLabel}
                      setSelectedDateLabel={setSelectedDateLabel}
                      searchVal={searchValue}
                    />
                  ) : (
                    <BasicMultiSelect
                      labelText={e?.labelText}
                      labelIcon={e?.labelIcon}
                      options={e?.options}
                      isDisabled={e?.isDisabled}
                      personName={personName}
                      setPersonName={setPersonName}
                      valid={valid}
                      setValid={setValid}
                      values={e?.value}
                      handleChange={e?.handleChange}
                    />
                  )}
                </div>
              ))}
            </div>

            {/* Filter Button */}
            <div className="filter-btn-wrapper">
              <Button
                variant="contained"
                className="filter-btn"
                onClick={handleFilter}
              >
                Apply
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
